module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('logo')], 1)], 1), _vm._v(" "), _c('nav', {
    staticClass: "row"
  }, _vm._l((_vm.menu), function(item) {
    return _c('router-link', {
      key: item.key,
      staticClass: "menu-item",
      attrs: {
        "to": {
          name: item.uri
        },
        "id": 'head-menu-link-' + item.uri.toLowerCase()
      },
      domProps: {
        "innerHTML": _vm._s(item.name)
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "manage row"
  }, [_c('router-link', {
    staticClass: "ctn-profil ctn-profile-picture",
    attrs: {
      "to": {
        name: 'Profile'
      }
    }
  }, [_c('img', {
    directives: [{
      name: "img-detect",
      rawName: "v-img-detect"
    }],
    attrs: {
      "src": _vm.picture,
      "alt": ""
    }
  })])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05a5ff82"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/header.vue
// module id = 1066
// module chunks = 0